export default String.raw`
{% for employee in customer-profile.Employees -%}
	<div class="customer-info customer-details-js container-js">
		<div class="customer-info__header">
			<strong>{{employee.Name}} {{employee.Name2}}</strong>
			<div class="edit container-js">
				<div class="form-js form-into-data-js">
					<input type="hidden" name="id" value="{{employee.Id}}" >
					<input type="hidden" name="__template" value="partials/customer-profile/employees-list/employees-view-lis.html" >
					{% if employee.Active -%}
						<input type="hidden" name="__action" value="Customer/EmployeeLock" >
						<div class="lock-popup-js lock-popup-{{employee.Id}}"></div>
						<button class="pure-button lock-pure set-focus-trap-js replace-template-js" data-template="partials/customer-profile/employees-list/lock-employee.html" data-container=".lock-popup-{{employee.Id}}">
                            <svg width="16" height="19">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{ settings.iconStyle }}"></use>
                            </svg>
							{{ translations.Lock }}
						</button>
					{% else-%}
						<input type="hidden" name="__action" value="Customer/EmployeeUnlock" >
						<button class="pure-button unlock-pure toggle-employee-js" data-container=".employees-list-view-js">
                            <svg width="16" height="19">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#unlock-alt-{{ settings.iconStyle }}"></use>
                            </svg>
							{{ translations.Unlock }}
						</button>
					{% endif -%}
				</div>
			</div>
		</div>
		<div class="customer-info__container">
			<div class="customer-info__content">
				<div class="title">{{ translations.Email }}</div>
				<span class="employee-email-js">{{employee.Email}}</span>
			</div>
			{% if employee.PhoneNo != '' -%}
			<div class="customer-info__content">
				<div class="title">{{ translations.Phone }}</div>
				<span>{{employee.PhoneNo}}</span>
			</div>
			{% endif -%}
		</div>
	</div>
{% endfor -%}
`